/**
 * Fixed copy of an event page (`/about-us/news-events/<slug>`): section headings, field labels,
 * button labels and the contact and all-events links, per language. The event's own text comes
 * from Contentful. Read only by `./EventDetails.tsx`.
 */
import { LanguageContent } from "@ryerson/frontend.common";
import { EventDetailsStaticContent } from "../types";

/** Event-page labels and links; `rsvp` and `withRyerson` are joined into the RSVP button label. */
export const StaticContent: LanguageContent<EventDetailsStaticContent> = {
	en: {
		moreInformation: "For more information visit",
		rsvp: "RSVP",
		withRyerson: "with Ryerson",
		registerToday: "Register Today",
		generalTitle: "General Event Information",
		dateLabel: "Event Date(s)",
		locationLabel: "Location",
		howToSignUp: "How To Sign Up",
		upcomingLabel: "Upcoming events",
		relatedLabel: "Related Posts",
		contactQuestion: "Need help or more information?",
		contactLinkLabel: "Contact Ryerson Professional",
		contactLinkUrl: "/contact-us",
		allEventsUrl: "/about-us/news-events",
		allEventsLabel: "All Events",
	},
	fr: {
		moreInformation: "Pour plus d'informations, visitez",
		rsvp: "RSVP",
		withRyerson: "avec Ryerson",
		registerToday: "Inscrivez-vous aujourd'hui",
		generalTitle: "Informations générales sur l'événement",
		dateLabel: "Dates des événements",
		locationLabel: "Lieu",
		howToSignUp: "Comment s'inscrire",
		upcomingLabel: "Évènements à venir",
		relatedLabel: "Articles Similaires",
		contactQuestion: "Besoin d'aide ou de plus d'informations ?",
		contactLinkLabel: "Contacter Ryerson Expert",
		allEventsUrl: "/about-us/news-events",
		allEventsLabel: "Tous les évènements",
		contactLinkUrl: "/contact-us",
	},
	es: {
		moreInformation: "Para más información visite",
		rsvp: "RSVP",
		withRyerson: "con Ryerson",
		registerToday: "Regístrese hoy",
		generalTitle: "Información General del Evento",
		dateLabel: "Fechas de eventos",
		locationLabel: "Ubicación",
		howToSignUp: "Cómo registrarse",
		upcomingLabel: "Próximos Eventos",
		relatedLabel: "Artículos Relacionados",
		contactQuestion: "¿Necesitas ayuda o más información?",
		contactLinkLabel: "Póngase en contacto con el experto de Ryerson",
		allEventsUrl: "/about-us/news-events",
		allEventsLabel: "Todos los eventos",
		contactLinkUrl: "/contact-us",
	},
};
